import { render, staticRenderFns } from "./EditComboNew.vue?vue&type=template&id=4b5d0cb2&scoped=true&"
import script from "./EditComboNew.vue?vue&type=script&lang=js&"
export * from "./EditComboNew.vue?vue&type=script&lang=js&"
import style0 from "./EditComboNew.vue?vue&type=style&index=0&id=4b5d0cb2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5d0cb2",
  null
  
)

export default component.exports